
import { editViewDraft } from '../../../../app/actions/spaces/EditViewAction';
import { hideLaunchEditOnMobile } from '../../../../app/utils/MobileHelper';
import { Messages } from '../../../../codegen/Localize';
import { ILaunchWebAuthoringAction } from '../../../../ts/ServerApi/types/actionNames';
import { IContentInfo } from '../../../models/IContentInfo';
import { EntityActionNames, IEntityAction } from './IEntityAction';

export const EditViewAction: IEntityAction<IContentInfo, ILaunchWebAuthoringAction> = {
  name: EntityActionNames.Edit,
  translateName: Messages.editView_action,
  isVisible: () => !hideLaunchEditOnMobile(),
  isClickable: (availableActions: ILaunchWebAuthoringAction) => !!(availableActions && availableActions.launchWebAuthoring),
  createReduxAction: (targetItems: IContentInfo[]) => {
    return editViewDraft(targetItems[0], 'ActionMenu_EditView');
  }
};
